<script setup lang="ts">

import { ref } from 'vue'
import { useGameStore } from '@/stores/gameStore.ts'
import MapFleetSideBarMine
  from '@/components/Sections/Map/Galaxy/WebGLMap/MapObjects/MapSideBar/Tabs/MapFleetSideBarMine.vue'
import MapFleetSideBarEnemy
  from '@/components/Sections/Map/Galaxy/WebGLMap/MapObjects/MapSideBar/Tabs/MapFleetSideBarEnemy.vue'
import MapFleetSideBarOther
  from '@/components/Sections/Map/Galaxy/WebGLMap/MapObjects/MapSideBar/Tabs/MapFleetSideBarOther.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore();

const currentTab = ref('mine');

</script>

<template>
  <div class="text-sm font-medium text-center border-b text-gray-400 border-gray-700">
    <ul class="flex flex-wrap">
      <li class="me-2">
        <a href="#"
           :class="{
               'active-blue': currentTab === 'mine',
               'text-blue-500 border-blue-500': currentTab === 'mine',
               'text-gray-500 border-transparent': currentTab !== 'mine',
               'inline-block p-4 border-b-2 rounded-t-lg hover:border-gray-300 hover:text-gray-300': true
           }"
           @click="currentTab = 'mine'">
          {{ gameStore.player?.nickName }}
        </a>
      </li>
      <li class="me-2">
        <a href="#"
           :class="{
               'active-blue': currentTab === 'enemy',
               'text-blue-500 border-blue-500': currentTab === 'enemy',
               'text-gray-500 border-transparent': currentTab !== 'enemy',
               'inline-block p-4 border-b-2 rounded-t-lg hover:border-gray-300 hover:text-gray-300': true
           }"
           @click="currentTab = 'enemy'">
          {{ t('map.sidebar.fleets.enemy') }}
        </a>
      </li>
      <li class="me-2">
        <a href="#"
           :class="{
               'active-blue': currentTab === 'other',
               'text-blue-500 border-blue-500': currentTab === 'other',
               'text-gray-500 border-transparent': currentTab !== 'other',
               'inline-block p-4 border-b-2 rounded-t-lg hover:border-gray-300 hover:text-gray-300': true
           }"
           @click="currentTab = 'other'">
          {{ t('map.sidebar.fleets.others') }}
        </a>
      </li>
    </ul>
  </div>
  <div v-if="currentTab === 'mine'" class="pt-1 px-1">
    <MapFleetSideBarMine/>
  </div>
  <div v-else-if="currentTab === 'enemy'" class="pt-1 px-1">
    <MapFleetSideBarEnemy/>
  </div>
  <div v-else-if="currentTab === 'other'" class="pt-1 px-1">
    <MapFleetSideBarOther/>
  </div>
</template>

<style scoped lang="scss">
.active-blue {
  background: linear-gradient(
    to top,
    rgba(59, 130, 246, 0.3) 0%,
    rgba(59, 130, 246, 0) 70%
  );
}
</style>